/* eslint-disable react/jsx-props-no-spreading */
import React from 'react'
import EditCompanyProfileScene from './scenes/EditCompanyProfileScene'

import './styles.css'

const EditCompanyProfileMain = ({ ...props }) => {
  return <EditCompanyProfileScene {...props} />
}

export default EditCompanyProfileMain
